import React, { Component } from "react";
import { connect } from "react-redux";

import "bootstrap/dist/js/bootstrap.bundle.min";
import "./App.scss";

import * as ConfigService from "./middleware/CommonSdk/ConfigService";
import * as AuthenticationActions from "./middleware/Store/Actions/AuthenticationActions";
import * as SearchActions from "./middleware/Store/Actions/SearchActions";
import * as ContactUtils from "./components/Utils/ContactUtils";
import * as AuthenticationUtils from "./middleware/Utils/AuthenticationUtils";
import *  as SentryService from "./middleware/CommonSdk/SentryService";
import HomePage from "./components/Screens/HomePage/HomePage";
import CookieConsent from "./components/Cookie/CookieConsent";
import Spinner, { SpinnerSize } from "./components/UI/Spinner/Spinner";
import * as Sentry from "@sentry/react";

import LogService from "./middleware/CommonSdk/LogService";

const LOG_TAG = "APP";
const LOCALHOST = "localhost";
const HUB_PREFIX_URL = "developers";

class App extends Component {
    state = { isInitialLoadFinished: false };

    componentDidMount() {
        LogService.trace(LOG_TAG, "componentDidMount");
        this.resolveBaseServerUrl()
            .then((serverUrl) => {
                this.props.setBaseServer(serverUrl);
                return this.props.authenticationCheckState();
            })
            .then(() => {
                if (this?.props.user == null)
                    this.setState({ isInitialLoadFinished: true });
            });
        this.loadSearchIndexFiles();
        SentryService.initializeSentry();
    }

    componentDidUpdate(prevProps) {
        LogService.trace(LOG_TAG, "componentDidUpdate");
        if (this.props.user && this.props.user !== prevProps.user) {
            LogService.debug(LOG_TAG, "componentDidUpdate", "user is diff");
            if (ContactUtils.isUserFullyLoaded(this.props.user))
                this.setState({ isInitialLoadFinished: true });
        }
    }

    resolveBaseServerUrl() {
        LogService.trace(LOG_TAG, "resolveBaseServerUrl");

        LogService.info(LOG_TAG, "resolveBaseServerUrl base server url", window.location.origin);
        let serverUrl = window.location.origin.replace("//" + HUB_PREFIX_URL + ".", "//");
        serverUrl = serverUrl.replace("//" + HUB_PREFIX_URL + "-", "//");//demo

        if (AuthenticationUtils.isPointComCnServer(serverUrl))
            serverUrl = serverUrl.replace(/(.*).com.cn$/, "$1.com");//cn
        if (AuthenticationUtils.isPointHealthServer(serverUrl))
            serverUrl = serverUrl.replace(/(.*).health$/, "$1.com");//health -> com

        const hostname = window.location.hostname;
        if (hostname && hostname === LOCALHOST) {
            serverUrl = "";
        }

        LogService.info(LOG_TAG, "resolveBaseServerUrl => check for config");
        return ConfigService.fetchConfigFile()
            .then((config) => {
                LogService.info(LOG_TAG, "resolveBaseServerUrl config success");
                if (config && config.webservices) {
                    serverUrl = config.webservices.protocol + "://" + config.webservices.server;
                } else {
                    LogService.warn(LOG_TAG, "resolveBaseServerUrl success no config found. use location url");
                }
                //todo CT use config.webservices.port
                return Promise.resolve(serverUrl);
            })
            .catch((err) => {
                LogService.error(LOG_TAG, "resolveBaseServerUrl error no config found. use location url");
                return Promise.resolve(serverUrl);
            });
    }

    loadSearchIndexFiles() {
        LogService.trace(LOG_TAG, "loadSearchIndexFiles");
        this.props.loadSearchIndexFiles();
    }

    render() {
        LogService.trace(LOG_TAG, "render");
        
        let homeContent = <div className="text-center py-xl state">
            <span className="state-icon">
                <Spinner size={SpinnerSize.Big} />
            </span>
        </div>;
        if (this.state.isInitialLoadFinished)
            homeContent = <HomePage user={this.props.user} isInitialLoadFinished={this.state.isInitialLoadFinished} />;

        let displayContent =
            <div>
                {homeContent}
                <CookieConsent />
            </div>;

        if (SentryService.getEnvironment() !== SentryService.Env.Development)
            displayContent =
                <Sentry.ErrorBoundary>
                    {homeContent}
                    <CookieConsent />
                </Sentry.ErrorBoundary>

        return displayContent;
    };
}

App.propTypes = {
};

const mapStateToProps = state => {
    return {
        user: state.contacts.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setBaseServer: (baseServerUrl) => dispatch(AuthenticationActions.setBaseServerEnvironment(baseServerUrl)),
        authenticationCheckState: () => dispatch(AuthenticationActions.authenticationCheckState()),
        loadSearchIndexFiles: () => dispatch(SearchActions.loadSearchIndexFiles()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
